import { useRouter } from "next/router";

function useIsDashboard(): boolean {
  const router = useRouter();

  return router.pathname.indexOf("dashboard") > -1 || router.pathname === "/";
}

export default useIsDashboard;
